import styled from '@emotion/styled'
import InlineSVG from 'svg-inline-react'

const Icon = styled(InlineSVG)`
  cursor: pointer;
  transform: scale(0.8);
  transition: opacity .2s ease;
  opacity: 0.8;
  &:hover {
    opacity: 1
  }
`
export default Icon